import api from '../../plugins/api';

const getSources = (params) => {
  return api.get('/api/resource/getSources', params);
};

export default getSources;
